<script>
	'use strict'
	import MorseDot from './components/MorseDot.svelte';
	import MorseLetterSpace from './components/MorseLetterSpace.svelte';
	import MorseLine from './components/MorseLine.svelte';
	import MorseWordSpace from './components/MorseWordSpace.svelte';
	import MorseLight from './components/MorseLight.svelte';
	import Settings from './components/Settings.svelte';
	import { loadUserSettings, setUserSettings } from './components/userSettings';

	// -------------------------------------------------
	const appname = 'mors.._re';
	const punchline = 'A tiny morse app';
	let userContent = 'sos';
	let morseContent = [];
	let isSpaced = true;
	const morseDictClassic = {
		a: '._',
		b: '_...',
		c: '_._',
		d: '_..',
		e: '.',
		f: '.._.',
		g: '__.',
		h: '....',
		i: '..',
		j: '.___',
		k: '_._',
		l: '._..',
		m: '__',
		n: '_.',
		o: '___',
		p: '.__.',
		q: '__._',
		r: '._.',
		s: '...',
		t: '_',
		u: '.._',
		v: '..._',
		w: '.__',
		x: '_.._',
		y: '_.__',
		z: '__..',
		space: '|'
	};
	const textToMorse = setMorseDict(morseDictClassic);
	let showLight = false;
	let showSettings = false;

	setUserSettings(loadUserSettings());

  // -------------------------------------------------
	$: {
		textToMorse(userContent, isSpaced);
		morseContent = getTextToMorseArray();
	}
  // -------------------------------------------------
	function setMorseDict(morseDict) {
		return function convertToMorse(txt, setSpace = false) {
			if (txt == '') { return ''; }
			let morse = '';
			for (let char of txt.toLowerCase()) {
				if (char == ' ') { char = 'space';}
				if (morseDict[char]) {
					if (setSpace) {
						morse += `${(morseDict[char].split('').map((l) => `${l} `).join(''))}°`;
					} else {
						morse += `${morseDict[char]}°`;
					}
				}
			}
			return morse.trim();
		}
	}

	function getTextToMorseArray() {
		return textToMorse(userContent).split('');
	}

	function switchLight() {
		showLight = !showLight;
	}
	
	function switchSettings() {
		showSettings = !showSettings;
	}
</script>

<!-- // ------------------------------------------------- \\-->
<!-- //                    TEMPLATE                       \\-->
<!-- // ------------------------------------------------- \\-->
{#if showLight}
	<MorseLight sequence={ morseContent } on:closeLight={ switchLight }/>
{:else}
	<div class="container">
		<header>
			<div>
				<h1>{ appname }</h1>
				<span class="subline">{ punchline } - 0.1.0</span>
			</div>
			<!-- Options button -->
			<div>
				<svg class="btn-svg btn-nav btn-light" on:click="{ switchLight }" xmlns="http://www.w3.org/2000/svg" style="isolation:isolate" viewBox="0 0 512 512">
					<defs>
						<clipPath id="a">
							<path d="M0 0h512v512H0z"/>
						</clipPath>
					</defs>
					<g clip-path="url(#a)">
						<path d="M325.947 177.322c-29.389-25.959-70.779-33.413-107.378-19.337-36.598 14.077-62.326 47.345-66.745 86.308a102.685 102.685 0 0 0 37.206 91.277 43.653 43.653 0 0 1 15.874 33.237v75.9h102.192v-74.411a44.147 44.147 0 0 1 14.882-33.237 105.17 105.17 0 0 0 3.969-159.737ZM214.826 434.785v-58.536h82.348v58.536h-82.348Zm101.199-105.167a54.07 54.07 0 0 0-18.355 36.709h-82.844a54.568 54.568 0 0 0-19.347-38.198 92.765 92.765 0 0 1-33.733-82.844c5.019-42.343 37.704-76.117 79.86-82.521 42.156-6.404 83.396 16.139 100.765 55.08 17.368 38.942 6.586 84.688-26.346 111.774ZM251.039 24.035h9.922v76.842h-9.922zM23.837 251.238h76.892v9.922H23.837zm387.435 0h76.892v9.922h-76.892zM88.625 416.8l54.362-54.363 7.015 7.015-54.362 54.363zm273.482-273.743 54.362-54.363 7.015 7.015-54.362 54.362zM88.493 95.838l7.015-7.014 54.327 54.327-7.014 7.015zm273.744 273.484 7.015-7.015 54.328 54.328-7.015 7.014z"/>
					</g>
				</svg>
				{#if !showSettings}
					<svg class="btn-svg btn-nav btn-settings" on:click="{ switchSettings }" xmlns="http://www.w3.org/2000/svg" style="isolation:isolate" viewBox="0 0 512 512">
						<defs>
							<clipPath id="b">
								<path d="M0 0h512v512H0z"/>
							</clipPath>
						</defs>
						<g clip-path="url(#b)">
							<path d="M260.961 444.707V211.552c22.711-2.404 39.947-21.561 39.947-44.399 0-22.839-17.236-41.995-39.947-44.399V52.808h-9.922v69.946c-22.711 2.404-39.947 21.56-39.947 44.399 0 22.838 17.236 41.995 39.947 44.399v233.155h9.922Zm-39.686-277.802c0-19.178 15.547-34.725 34.725-34.725s34.725 15.547 34.725 34.725S275.178 201.63 256 201.63s-34.725-15.547-34.725-34.725Zm176.106 277.802V374.76c22.712-2.404 39.948-21.56 39.948-44.398 0-22.839-17.236-41.995-39.948-44.399V52.808h-9.921v233.155c-22.712 2.404-39.947 21.56-39.947 44.399 0 22.838 17.235 41.994 39.947 44.398v69.947h9.921ZM357.695 330.61c0-19.179 15.547-34.726 34.726-34.726 19.178 0 34.725 15.547 34.725 34.726 0 19.178-15.547 34.725-34.725 34.725-19.179 0-34.726-15.547-34.726-34.725ZM124.54 444.707V374.76c22.712-2.404 39.947-21.56 39.947-44.398 0-22.839-17.235-41.995-39.947-44.399V52.808h-9.921v233.155c-22.712 2.404-39.948 21.56-39.948 44.399 0 22.838 17.236 41.994 39.948 44.398v69.947h9.921ZM84.854 330.61c0-19.179 15.547-34.726 34.725-34.726 19.179 0 34.726 15.547 34.726 34.726 0 19.178-15.547 34.725-34.726 34.725-19.178 0-34.725-15.547-34.725-34.725Z"/>
						</g>
					</svg>
				{:else}
					<svg class="btn-svg btn-nav btn-settings" on:click="{ switchSettings }" xmlns="http://www.w3.org/2000/svg" style="isolation:isolate" viewBox="0 0 512 512">
						<defs>
							<clipPath id="a">
								<path d="M0 0h512v512H0z"/>
							</clipPath>
						</defs>
						<g clip-path="url(#a)">
							<path fill="none" d="M0 0h512v512H0z"/>
							<mask id="b">
								<circle vector-effect="non-scaling-stroke" cx="120.5" cy="99.5" r="40.5" fill="#fff"/>
							</mask>
							<circle vector-effect="non-scaling-stroke" cx="120.5" cy="99.5" r="40.5" fill="none"/>
							<circle vector-effect="non-scaling-stroke" cx="120.5" cy="99.5" r="40.5" fill="none" mask="url(#b)" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="3"/>
							<mask id="c">
								<circle vector-effect="non-scaling-stroke" cx="391.5" cy="99.5" r="40.5" fill="#fff"/>
							</mask>
							<circle vector-effect="non-scaling-stroke" cx="391.5" cy="99.5" r="40.5" fill="none"/>
							<circle vector-effect="non-scaling-stroke" cx="391.5" cy="99.5" r="40.5" fill="none" mask="url(#c)" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="3"/>
							<mask id="d">
								<path fill="#fff" d="M176 60h160v80H176z"/>
							</mask>
							<path fill="none" d="M176 60h160v80H176z"/>
							<path fill="none" mask="url(#d)" vector-effect="non-scaling-stroke" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="2" d="M176 60h160v80H176z"/>
							<mask id="e">
								<circle vector-effect="non-scaling-stroke" cx="295.5" cy="308.167" r="40.5" fill="#fff"/>
							</mask>
							<circle vector-effect="non-scaling-stroke" cx="295.5" cy="308.167" r="40.5" fill="none"/>
							<circle vector-effect="non-scaling-stroke" cx="295.5" cy="308.167" r="40.5" fill="none" mask="url(#e)" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="3"/>
							<mask id="f">
								<circle vector-effect="non-scaling-stroke" cx="391.5" cy="308.167" r="40.5" fill="#fff"/>
							</mask>
							<circle vector-effect="non-scaling-stroke" cx="391.5" cy="308.167" r="40.5" fill="none"/>
							<circle vector-effect="non-scaling-stroke" cx="391.5" cy="308.167" r="40.5" fill="none" mask="url(#f)" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="3"/>
							<mask id="g">
								<path fill="#fff" d="M80 267.667h160v80H80z"/>
							</mask>
							<path fill="none" d="M80 267.667h160v80H80z"/>
							<path fill="none" mask="url(#g)" vector-effect="non-scaling-stroke" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="2" d="M80 267.667h160v80H80z"/>
							<mask id="h">
								<path d="M257 203.833c0 22.353-18.147 40.5-40.5 40.5s-40.5-18.147-40.5-40.5c0-22.352 18.147-40.5 40.5-40.5s40.5 18.148 40.5 40.5Z" fill="#fff"/>
							</mask>
							<path d="M257 203.833c0 22.353-18.147 40.5-40.5 40.5s-40.5-18.147-40.5-40.5c0-22.352 18.147-40.5 40.5-40.5s40.5 18.148 40.5 40.5Z" fill="none"/>
							<path d="M257 203.833c0 22.353-18.147 40.5-40.5 40.5s-40.5-18.147-40.5-40.5c0-22.352 18.147-40.5 40.5-40.5s40.5 18.148 40.5 40.5Z" fill="none" mask="url(#h)" vector-effect="non-scaling-stroke" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="3"/>
							<mask id="i">
								<path d="M161 203.833c0 22.353-18.147 40.5-40.5 40.5S80 226.186 80 203.833c0-22.352 18.147-40.5 40.5-40.5s40.5 18.148 40.5 40.5Z" fill="#fff"/>
							</mask>
							<path d="M161 203.833c0 22.353-18.147 40.5-40.5 40.5S80 226.186 80 203.833c0-22.352 18.147-40.5 40.5-40.5s40.5 18.148 40.5 40.5Z" fill="none"/>
							<path d="M161 203.833c0 22.353-18.147 40.5-40.5 40.5S80 226.186 80 203.833c0-22.352 18.147-40.5 40.5-40.5s40.5 18.148 40.5 40.5Z" fill="none" mask="url(#i)" vector-effect="non-scaling-stroke" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="3"/>
							<mask id="j">
								<path fill="#fff" d="M272 164.333h160v80H272z"/>
							</mask>
							<path fill="none" d="M432 244.334H272v-80h160z"/>
							<path transform="rotate(180 352 204.333)" fill="none" mask="url(#j)" vector-effect="non-scaling-stroke" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="2" d="M272 164.333h160v80H272z"/>
							<mask id="k">
								<path fill="#fff" d="M80 372h160v80H80z"/>
							</mask>
							<path fill="none" d="M80 372h160v80H80z"/>
							<path fill="none" mask="url(#k)" vector-effect="non-scaling-stroke" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="2" d="M80 372h160v80H80z"/>
							<mask id="l">
								<path fill="#fff" d="M271 373h160v80H271z"/>
							</mask>
							<path fill="none" d="M271 373h160v80H271z"/>
							<path fill="none" mask="url(#l)" vector-effect="non-scaling-stroke" stroke-width="20" stroke="#000" stroke-linecap="square" stroke-miterlimit="2" d="M271 373h160v80H271z"/>
						</g>
					</svg>
				{/if}
			</div>
		</header>

		{#if showSettings}
			<div>
				<Settings />
			</div>
		{:else}
			<div>
				<textarea class="user-content-area" bind:value={userContent} placeholder="Type here ..."></textarea>
				<div class="morse-signal">
					{#each morseContent as letter}
						{#if letter === '.'}
							<MorseDot />
						{:else if letter === '_'}
							<MorseLine />
						{:else if letter === '°'}
							<MorseLetterSpace />
						{:else}
							<MorseWordSpace />
						{/if}
					{/each}
				</div>
			</div>
		{/if}

	</div>
{/if}



<!-- <p>{ userContent }</p>
<input type="checkbox" bind:checked={isSpaced}>
<p>isSpaced: { isSpaced }</p>
<p>{ textToMorse(userContent, isSpaced) }</p> -->



<!-- // ------------------------------------------------- \\-->
<!-- //                       STYLE                       \\-->
<!-- // ------------------------------------------------- \\-->
<style>
	/* 
		0: background color
		1: text color
		2: morse line color
		3: morse dot color
		4: light color
	*/
	:root {
		--color-0: #061a2d;	
		--color-1: #ffbb00;	
		--color-2: #00ffbf;	
		--color-3: #ffbb00;	
		--color-4: #ffffff;
		--color-5: #f24545;
	}

	header {
		display: flex;
		justify-content: space-between;
		margin: 6px 0;
	}

	h1 {
		margin: 0;
	}
	.subline {
		font-size: 0.7em;
	}

	.container {
		padding: 2ch;
		max-width: 768px;
		margin: auto;
	}

	.btn-svg {
		border: 1px solid black;
		padding: 6px;
		margin: 0 3px;
		width: 40px;
	}

	.btn-nav {
		border-radius: 12px;
	}

	.btn-light {
		background-color: var(--color-1);
		fill: var(--color-0) !important;
	}
	
	.btn-settings {
		background-color: var(--color-2);
		fill: var(--color-0) !important;
	}
  .user-content-area {
		width: 100%;
		resize: vertical;
		background-color: transparent;
    color: var(--color-1);
    margin: 5vh 0;
    height: 25vh;
		border: 1px solid var(--color-1);
    border-radius: 12px;
    padding: 12px;
		font-size: 1.5rem;
	}
	.user-content-area::placeholder {
		color: gray;
		font-size: 0.8rem;
		font-style: italic;
	}
	.user-content-area:placeholder-shown {
		background: rgba(211, 211, 211, 0.3);
	}

	.morse-signal {
		display: flex;
		flex-wrap: wrap;
	}
	.morse-signal > div {
		margin-right: 3px;
	}
</style>

